module.exports = __webpack_public_path__ + "static/img/scene1.bae730f4.jpg";